import { render, staticRenderFns } from "./SelfProjects.vue?vue&type=template&id=1746502a&"
import script from "./SelfProjects.vue?vue&type=script&lang=js&"
export * from "./SelfProjects.vue?vue&type=script&lang=js&"
import style0 from "./SelfProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports